// removed by extract-text-webpack-plugin
module.exports = {"root":"src-components-Common-Audio-index-root-1R8XZ","enable":"src-components-Common-Audio-index-enable-KAxLP","wrap":"src-components-Common-Audio-index-wrap-35P6A","controlButton":"src-components-Common-Audio-index-controlButton-7ukcj","play":"src-components-Common-Audio-index-play-23bEQ","pause":"src-components-Common-Audio-index-pause-1I3Ge","info":"src-components-Common-Audio-index-info-rnC4X","time":"src-components-Common-Audio-index-time-zma5q","progress":"src-components-Common-Audio-index-progress-3jyWs","buffered":"src-components-Common-Audio-index-buffered-26V2x","played":"src-components-Common-Audio-index-played-1xC7e"};


/*****************
 ** WEBPACK FOOTER
 ** ./src/components/Common/Audio/index.css
 ** module id = 257
 ** module chunks = 0
 **/